import { getChromeAlarms } from './chrome/wrappers';
import {
  CURRENT_SAFE_NETWORK_UPDATE_ALARM_NAME,
  onUpdateActiveSafeNetworkRetry,
} from './safeNetworks/safeNetworksProbe';
import { now } from './lib/dateTime';

/**
 * Setup the callbacks for the scheduled alarms.
 *
 * This should be called as soon as possible to prevent race conditions.
 */
export const setupAlarmsCallbacks = (initializeData: () => Promise<void>) => {
  getChromeAlarms().onAlarm.addListener(async alarm => {
    // Safe Networks state retries
    if (alarm.name === CURRENT_SAFE_NETWORK_UPDATE_ALARM_NAME) {
      await initializeData();
      await onUpdateActiveSafeNetworkRetry();
    }
  });
};

export const createAlarmWithDelay = (name: string, delayInMinutes: number) =>
  getChromeAlarms().create(name, {
    when: now() + delayInMinutes * 60 * 1000,
  });
